<template>
    <div class="sspace-top-0 space-bottom-1">
      <div class="alert alert-primary">
        <button v-if="!usingDefault" class="position-absolute btn btn-lg btn-link right-0 top-0 text-white" @click="$emit('closed')"><i class="fas fa-times"></i></button>
        <h2 class="alert-heading">Take a look at these Best Buys...</h2>
        <ProductQuerySummary v-if="usingDefault" :query="searchQuery" :is-example="usingDefault" :no-click="usingDefault"/>
      </div>
      <div class="card card-hover-shadow card-bordered" style="border-width: 2px;">
          <div class="card-body my-3">
            <ul class="best-buy-card">
              <li v-if="data.lowestAprc != null">
                <span class="text-secondary font-size-1 d-block">Best<br/>APRC</span>
                <div>
                  <a :href="data.lowestAprc.lender.mortgagesUrl" target="_new"><img :src="data.lowestAprc.lender.imageUrl" :title="data.lowestAprc.lender.lenderName" :alt="data.lowestAprc.lender.lenderName" style="width: 90%; max-width: 132px"/></a>
                </div>
                <div class="font-size-2 strong mb-2">
                  {{ (data.lowestAprc.calculations.aprc) | prettyInterestRate }}
                </div>
                <button class="btn btn-xs btn-soft-success" @click="isAprcOpen = !isAprcOpen">{{ isAprcOpen ? "Hide" : "More Details"}}</button>
              </li>
              <li v-if="data.lowestMonthlyCost != null">
                <span class="text-secondary font-size-1 d-block">Lowest<br/>£ Monthly Payment</span>
                <div>
                  <a :href="data.lowestMonthlyCost.lender.mortgagesUrl" target="_new"><img :src="data.lowestMonthlyCost.lender.imageUrl" :title="data.lowestMonthlyCost.lender.lenderName" :alt="data.lowestMonthlyCost.lender.lenderName" style="width: 90%; max-width: 132px"/></a>
                </div>
                <div class="font-size-2 strong mb-2">
                  {{( data.lowestMonthlyCost.isFixedProduct ? data.lowestMonthlyCost.calculations.initialMonthlyCost : data.lowestMonthlyCost.calculations.regularMonthlyCost) | prettyMoney }}
                </div>
                <button class="btn btn-xs btn-soft-success" @click="isMonthlyPaymentOpen = !isMonthlyPaymentOpen">{{ isMonthlyPaymentOpen ? "Hide" : "More Details"}}</button>
              </li>
              <li v-if="data.lowestInterestRate != null">
                <span class="text-secondary font-size-1 d-block">Lowest<br/>Initial Rate</span>
                <div>
                  <a :href="data.lowestInterestRate.lender.lowestInterestRate" target="_new"><img :src="data.lowestInterestRate.lender.imageUrl" :title="data.lowestInterestRate.lender.lenderName" :alt="data.lowestInterestRate.lender.lenderName" style="width: 90%; max-width: 132px"/></a>
                </div>
                <div class="font-size-2 strong mb-2">
                  {{ (data.lowestInterestRate.isFixedProduct ? data.lowestInterestRate.initialInterestRate : data.lowestInterestRate.interestRate) | prettyInterestRate }}
                </div>
                <button class="btn btn-xs btn-soft-success" @click="isInitialRateOpen = !isInitialRateOpen">{{ isInitialRateOpen ? "Hide" : "More Details"}}</button>
              </li>
              <li v-if="data.lowestTotalCost != null">
                <span class="text-secondary font-size-1 d-block">Lowest<br/>£ Total Cost</span>
                <div>
                  <a :href="data.lowestTotalCost.lender.mortgagesUrl" target="_new"><img :src="data.lowestTotalCost.lender.imageUrl" :title="data.lowestTotalCost.lender.lenderName" :alt="data.lowestTotalCost.lender.lenderName" style="width: 90%; max-width: 132px"/></a>
                </div>
                <div class="font-size-2 strong mb-2">
                  {{ data.lowestTotalCost.calculations.fullTermCost | prettyMoney }}
                </div>
                <button class="btn btn-xs btn-soft-success" @click="isTotalCostOpen = !isTotalCostOpen">{{ isTotalCostOpen ? "Hide" : "More Details"}}</button>
              </li>
              <li v-if="data.greatestMonthlySaving != null">
                <span class="text-secondary font-size-1 d-block">Biggest<br/>£ Monthly Saving</span>
                <div>
                  <a :href="data.greatestMonthlySaving.lender.mortgagesUrl" target="_new"><img :src="data.greatestMonthlySaving.lender.imageUrl" :title="data.greatestMonthlySaving.lender.lenderName" :alt="data.greatestMonthlySaving.lender.lenderName" style="width: 90%; max-width: 132px"/></a>
                </div>
                <div class="font-size-2 strong mb-2">
                  <MoneySaved :amount="data.lowestTotalCost.calculations.monthlySaving"></MoneySaved>
                </div>
                <button class="btn btn-xs btn-soft-success" @click="isMonthlySavingOpen = !isMonthlySavingOpen">{{ isMonthlySavingOpen ? "Hide" : "More Details"}}</button>
              </li>
            </ul>
        </div>
      </div>
      <div class="row">
        <div v-if="isAprcOpen" class="mt-5 col-md-12 text-center">
          <ProductCard banner="Best APRC" :item="data.lowestAprc" :hide-monthly-cost="usingDefault" :monthly-comparison="searchQuery.currentMonthly" :query="searchQuery"/>
        </div>
        <div v-if="isMonthlyPaymentOpen" class="mt-5 col-md-12 text-center">
          <ProductCard banner="Lowest Monthly Payment" :item="data.lowestMonthlyCost" :hide-monthly-cost="usingDefault" :monthly-comparison="searchQuery.currentMonthly" :query="searchQuery"/>
        </div>
        <div v-if="isInitialRateOpen" class="mt-5 col-md-12 text-center">
          <ProductCard banner="Lowest Interest Rate" :item="data.lowestInterestRate" :hide-monthly-cost="usingDefault" :monthly-comparison="searchQuery.currentMonthly" :query="searchQuery"/>
        </div>
        <div v-if="isTotalCostOpen" class="mt-5 col-md-12 text-center">
          <ProductCard banner="Lowest Total Cost" :item="data.lowestTotalCost" :hide-monthly-cost="usingDefault" :monthly-comparison="searchQuery.currentMonthly" :query="searchQuery"/>
        </div>
        <div v-if="isMonthlySavingOpen" class="mt-5 col-md-12 text-center">
          <ProductCard banner="Greatest Monthly Saving" :item="data.greatestMonthlySaving" :hide-monthly-cost="usingDefault" :monthly-comparison="searchQuery.currentMonthly" :query="searchQuery"/>
        </div>
      </div>
    </div>
</template>

<script>
    import ProductCardDetails from "@/components/products/ProductCardDetails";
    import { mapActions, mapGetters } from "vuex";
    import MoneySaved from "@/components/products/MoneySaved";
    import ProductCard from "@/components/products/ProductCard";
    import ProductQuerySummary from "@/components/products/ProductQuerySummary";
    
    export default {
      name: "BestBuyCard",
      components: {ProductQuerySummary, ProductCard, MoneySaved},
      props: {
        data: Object,
        searchQuery: Object,
        usingDefault: Boolean
      },

      data() {
        return {
          isAprcOpen: false,
          isMonthlyPaymentOpen: false,
          isInitialRateOpen: false,
          isTotalCostOpen: false,
          isMonthlySavingOpen: false
        }
      },
      
      methods: {
      },
      
      computed: {
      }
    }
</script>

<style scoped>
    .best-buy-card {
      display: table;      /* Required for table-cell to work on li's */
      padding: 0;          /* Override defaults for lists */
      margin: 5px;           /* Override defaults for lists */
      width: 100%;         /* Get the row full width */
      text-align: center;  /* Centre align grid items */
    }
    
    .best-buy-card li {
      display: table-cell;   /* Get all images to show in a row */
      text-align: center;    /* Centre align the images */
      width: 15%;
      margin-top: 3px;
      margin-bottom: 12px;
      border-right: solid 1px #e0e0e0;
    }
    
    .best-buy-card li:hover {
    }
    
    .best-buy-card li:last-child {
      border-right: none;
    }
    
    @media (max-width: 960px) and (min-width: 501px) {
      .best-buy-card li { width: 50%; } /* Show 2 logos per row on medium devices (tablets, phones in landscape) */
    }
    
    @media (max-width: 500px) {
      .best-buy-card li { width: 100%; } /* On small screens, show one logo per row */
    }
    
    @media (max-width: 960px) {
      .best-buy-card {
        display: block;
      }
    
      .best-buy-card li {
        display: inline-block;
      }
    }
    
    div.card-stat {
        border-left: 1px solid #e0e0e0;
        line-height: 1.6rem;
        padding-bottom: 12px;
    }
    
    .card-body {
        padding: 0.25rem !important;
    }
</style>